import React, { useState, useEffect, useRef } from "react";


const TextToSpeech = ({ text }) => {
   const [voice, setVoice] = useState(null);
  const synthRef = useRef(window.speechSynthesis);

  const pitch = 1;
  const rate = 0.8;
  const volume = 1;

  const selectVoice = () => {
    const synth = synthRef.current;
    const voices = synth.getVoices();

    const preferred =
      voices.find(
        (v) =>
          v.name.includes("Google") &&
          v.name.includes("普通话") &&
          v.lang?.toLowerCase().includes("zh") &&
          (v.lang.toLowerCase().includes("hans") ||
            v.lang.toLowerCase() === "zh-cn" ||
            v.lang.toLowerCase() === "zh_cn")
      ) ||
      voices.find(
        (v) =>
          v.name ===
            "Microsoft Xiaoxiao Online (Natural) - Chinese (Mainland)" &&
          v.lang?.toLowerCase().includes("zh") &&
          (v.lang.toLowerCase().includes("hans") ||
            v.lang.toLowerCase() === "zh-cn" ||
            v.lang.toLowerCase() === "zh_cn")
      ) ||
      voices.find(
        (v) =>
          v.name === "Microsoft Xiaoxiao Online (Natural) - zh-CN" &&
          v.lang?.toLowerCase().includes("zh") &&
          (v.lang.toLowerCase().includes("hans") ||
            v.lang.toLowerCase() === "zh-cn" ||
            v.lang.toLowerCase() === "zh_cn")
      );

    if (preferred) return preferred;

    // Fallback: any Simplified Chinese
    return (
      voices.find(
        (v) =>
          v.lang?.toLowerCase().includes("zh") &&
          (v.lang.toLowerCase().includes("hans") ||
            v.lang.toLowerCase() === "zh-cn" ||
            v.lang.toLowerCase() === "zh_cn")
      ) || null
    );
  };

  useEffect(() => {
    const synth = synthRef.current;

    const loadVoices = (attempt = 0) => {
      const voices = synth.getVoices();

      if (voices.length > 0) {
        const selected = selectVoice();
        setVoice(selected);
      } else if (attempt < 10) {
        setTimeout(() => loadVoices(attempt + 1), 300);
      }
    };

    synth.addEventListener("voiceschanged", loadVoices);
    loadVoices();

    return () => {
      synth.cancel();
      synth.removeEventListener("voiceschanged", loadVoices);
    };
  }, []);

  const handlePlay = () => {
    const synth = synthRef.current;

    if (!/[\u4E00-\u9FFF]/.test(text)) return;

    const currentVoice = voice || selectVoice();
    const lang = currentVoice?.lang?.toLowerCase();

    if (
      !currentVoice ||
      !lang.includes("zh") ||
      (!lang.includes("hans") && lang !== "zh-cn" && lang !== "zh_cn")
    ) {
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = currentVoice;
    utterance.lang = "zh-CN";
    utterance.pitch = pitch;
    utterance.rate = rate;
    utterance.volume = volume;

    synth.cancel();
    setTimeout(() => synth.speak(utterance), 100);
  };

  return (
      <div className="audioSVG" onClick={handlePlay}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="#808080" width="60px" height="60px" viewBox="-1.5 0 19 19" className="cf-icon-svg"><path d="M7.098 4.769v9.63c0 .61-.353.756-.784.325L3.42 11.828H1.442A1.112 1.112 0 0 1 .333 10.72V8.448A1.112 1.112 0 0 1 1.442 7.34h1.977l2.895-2.896c.431-.43.784-.285.784.325zm2.076 7.474a.553.553 0 0 0 .392-.163 3.53 3.53 0 0 0 0-4.992.554.554 0 1 0-.784.784 2.422 2.422 0 0 1 0 3.425.554.554 0 0 0 .392.946zm2.184 1.629a6.059 6.059 0 0 0 0-8.575.554.554 0 0 0-.784.783 4.955 4.955 0 0 1 0 7.008.554.554 0 0 0 .784.784zm1.79 1.79a8.59 8.59 0 0 0 0-12.157.554.554 0 0 0-.783.784 7.481 7.481 0 0 1 0 10.59.554.554 0 1 0 .784.784z"/></svg>
      </div>
  );
};

export default TextToSpeech;
